module.exports = __webpack_public_path__ + "static/img/极空间 T2S智能魔盒.0ee5a3b5.png";